import { GetCountriesResult } from "Interfaces/GetReservations";
import { Actions, ArrivingGuestInfoAction, ArrivingGuestInfoState, GuestName, InitState, PageErrorType, PageErrors, ReservationDetails } from "./types";
import { ADDRESS, BONVOYNUMBER, CITY, COUNTRY, EMAIL, FIRSTNAME, LASTNAME, PHONE, STATE, ZIPCODE } from "./strings";
import { Term } from "Interfaces/BookResort";

export const ArrivingGuestInfoReducer = (state: ArrivingGuestInfoState, action: ArrivingGuestInfoAction): ArrivingGuestInfoState => {
    const { type, payload } = action;

    switch (type) {
        case Actions.SETDATA:
            const reservationDetails: ReservationDetails = payload.reservationDetails;
            const countries: GetCountriesResult[] = payload.countries;

            console.log("Terms from reducer: " + JSON.stringify(payload.terms));
            
            return {
                ...state,
                isLoading: false,
                countries: countries,
                reservationResult: {
                    ...state.reservationResult,
                    firstName: reservationDetails.firstName,
                    lastName: reservationDetails.lastName,
                    address: reservationDetails.address,
                    city: reservationDetails.city,
                    state: reservationDetails.state,
                    zipcode: reservationDetails.zipcode,
                    country: reservationDetails.country,
                    email: reservationDetails.email,
                    phone: reservationDetails.phone,
                    bonvoyNumber: reservationDetails.bonvoyNumber,
                    guestNames: reservationDetails.guestNames,
                    numOfGuests: reservationDetails.numOfGuests,
                    checkInDate: reservationDetails.checkInDate,
                    numOfNights: reservationDetails.numOfNights,
                    roomTypeDescription: reservationDetails.roomTypeDescription,
                    reservationConfirmationNumber: reservationDetails.reservationConfirmationNumber,
                    resortName: reservationDetails.resortName,
                    resortLocation: reservationDetails.resortLocation,
                    guestRadioButton: reservationDetails.guestRadioButton,
                    originalPrimaryGuestInfo: reservationDetails.originalPrimaryGuestInfo,
                    orignialGuestInfo: reservationDetails.guestNames,
                    // originalReservationDetail: reservationDetails
                    ownerStayOption: "",
                },
                terms: payload.terms,
            }

        case Actions.ERROR:
            const type: string = payload.type;
            if(type === "apiError") {
                return {
                    ...state,
                    isLoading: false,
                    pageErrors: {
                        ...state.pageErrors,
                        [PageErrorType.apiError]: {...state.pageErrors[PageErrorType.apiError], isErrored: true}
                    }
                }
            } else if(type === "globalError") {
                const validationMap: Map<String, Boolean> = payload.errorMap;

                let pageErrors: PageErrors = JSON.parse(JSON.stringify(state.pageErrors));
                let guestNames = JSON.parse(JSON.stringify(state.reservationResult.guestNames));

                if(validationMap.get("termsError")) {
                    pageErrors[PageErrorType.tandcError].isErrored = true;
                }

                if(validationMap.get("additionalGuestError")) {
                    pageErrors[PageErrorType.additionalGuestsError].isErrored = true;
                    //also need to set the boxes which are empty
                    guestNames.forEach((guest: GuestName) => {
                        if(guest.firstName.trim().length === 0) {
                            guest.errors.firstNameError = true;
                        }
                        if(guest.lastName.trim().length === 0) {
                            guest.errors.lastNameError = true;
                        }
                    });
                }

                if(validationMap.get("addressError")) {
                    pageErrors[PageErrorType.addressError].isErrored = true;
                }

                if(validationMap.get("cityError")) {
                    pageErrors[PageErrorType.cityError].isErrored = true;
                }

                if(validationMap.get("stateError")) {
                    pageErrors[PageErrorType.stateError].isErrored = true;
                }

                if(validationMap.get("zipError")) {
                    pageErrors[PageErrorType.zipError].isErrored = true;
                }

                if(validationMap.get("emailError")) {
                    pageErrors[PageErrorType.emailError].isErrored = true;
                }

                if(validationMap.get("phoneError")) {
                    pageErrors[PageErrorType.phoneError].isErrored = true;
                }

                if(validationMap.get("bonvoyError")) {
                    pageErrors[PageErrorType.bonvoyError].isErrored = true;
                }

                return {
                    ...state,
                    pageErrors: pageErrors,
                    reservationResult: {
                        ...state.reservationResult,
                        guestNames: guestNames
                    },
                    hasPageErrors: true
                }
            } else if(type === "langError") {
                let pageErrors: PageErrors = JSON.parse(JSON.stringify(state.pageErrors));
                const errorMsg: string = payload.message;
                pageErrors[PageErrorType.langError].isErrored = true;
                pageErrors[PageErrorType.langError].message = errorMsg;
                return {
                    ...state,
                    pageErrors: pageErrors,
                }
            }
            
        case Actions.ADDPRIMARYGUESTINFO:
            if(payload.fieldName === STATE) {
                /**
                 * 1. get selected country
                 * 2. Get states from those countries
                 * 3. get state from state array in countries
                 * 4. set state
                 */

                const country = state.countries.find((country: GetCountriesResult) => {
                    return country.Name === state.reservationResult.country;
                });

                const selectedState = country!.State.find((state: GetCountriesResult) => {
                    return state.Name === payload.value;
                });
                console.log('selectedState', selectedState);
                console.log('country', country);

                return {
                    ...state,
                    hasPageErrors: false,
                    reservationResult: {
                        ...state.reservationResult,
                        state: selectedState !== undefined || null ? selectedState!.Name : 'N/A'
                    }
                };
            }

            if(payload.fieldName === COUNTRY) {
                const country = state.countries.find((country: GetCountriesResult) => {
                    return country.Name === payload.value;
                });

                if(country && country.State.length === 0) {
                    //disable the state field
                    return {
                        ...state,
                        hasPageErrors: false,
                        reservationResult: {
                            ...state.reservationResult,
                            country: country!.Name,
                            state: "N/A"
                        }
                    }
                }

                return {
                    ...state,
                    hasPageErrors: false,
                    reservationResult: {
                        ...state.reservationResult,
                        country: country!.Name,
                        state: country!.State[0].Name
                    }
                }
            }

            let primaryGuestInfoErrorsSetData: PageErrors = JSON.parse(JSON.stringify(state.pageErrors));

            if(payload.fieldName === ADDRESS && state.pageErrors[PageErrorType.addressError].isErrored) {
                primaryGuestInfoErrorsSetData[PageErrorType.addressError].isErrored = false;
            } else if(payload.fieldName === ZIPCODE && state.pageErrors[PageErrorType.zipError].isErrored) {
                primaryGuestInfoErrorsSetData[PageErrorType.zipError].isErrored = false;
            } else if(payload.fieldName === CITY && state.pageErrors[PageErrorType.cityError].isErrored) {
                primaryGuestInfoErrorsSetData[PageErrorType.cityError].isErrored = false;
            } else if(payload.fieldName === EMAIL && state.pageErrors[PageErrorType.emailError].isErrored) {
                primaryGuestInfoErrorsSetData[PageErrorType.emailError].isErrored = false;
            } else if(payload.fieldName === PHONE && state.pageErrors[PageErrorType.phoneError].isErrored) {
                primaryGuestInfoErrorsSetData[PageErrorType.phoneError].isErrored = false;
            } else if(payload.fieldName === BONVOYNUMBER && state.pageErrors[PageErrorType.bonvoyError].isErrored) {
                primaryGuestInfoErrorsSetData[PageErrorType.bonvoyError].isErrored = false;
            } else if(payload.fieldName === FIRSTNAME && state.pageErrors[PageErrorType.firstNameError].isErrored) {
                primaryGuestInfoErrorsSetData[PageErrorType.firstNameError].isErrored = false;
            } else if(payload.fieldName === LASTNAME && state.pageErrors[PageErrorType.lastNameError].isErrored) {
                primaryGuestInfoErrorsSetData[PageErrorType.lastNameError].isErrored = false;
            }
            
            primaryGuestInfoErrorsSetData[PageErrorType.langError].isErrored = false;

            const newReservationDetails: ReservationDetails = {
                ...state.reservationResult,
                [payload.fieldName]: payload.value
            };

            // console.log(JSON.stringify(newReservationDetails));

            return {
                ...state,
                hasPageErrors: false,
                pageErrors: primaryGuestInfoErrorsSetData,
                reservationResult: newReservationDetails
            };

        case Actions.ADDITIONALGUESTINFOMODIFY:
            const index: number = payload.index;
            const fieldNameForGuest: string = payload.fieldName;
            let additionalGuests: GuestName[] = JSON.parse(JSON.stringify(state.reservationResult.guestNames));
            let guestName: GuestName = additionalGuests[index];

            if(fieldNameForGuest === "firstName") {
                guestName.firstName = payload.value;
                guestName.errors.firstNameError = false;
            } else {
                guestName.lastName = payload.value;
                guestName.errors.lastNameError = false;
            }

            let additionalGuestInfoErrorsSetData: PageErrors = JSON.parse(JSON.stringify(state.pageErrors));
            additionalGuestInfoErrorsSetData[PageErrorType.langError].isErrored = false;

            //loop through all the additional guest names and if all have set values, then reset error
            if(state.pageErrors.additionalGuestsError.isErrored) {
                if(additionalGuests.every((guest: GuestName) => guest.firstName && guest.firstName.trim().length > 0 && guest.lastName && guest.lastName.trim().length > 0)) {
                    return {
                        ...state,
                        reservationResult: {
                            ...state.reservationResult,
                            guestNames: additionalGuests
                        },
                        pageErrors: {
                            ...state.pageErrors,
                            [PageErrorType.additionalGuestsError]: {...state.pageErrors[PageErrorType.additionalGuestsError], isErrored: false},
                            [PageErrorType.langError]: {...state.pageErrors[PageErrorType.langError], isErrored: false}
                        }
                    }
                }
            }

            // if(state.hasPageErrors) {
            //     return {
            //         ...state,
            //         hasPageErrors: false,
            //         reservationResult: {
            //             ...state.reservationResult,
            //             guestNames: additionalGuests
            //         }
            //     }
            // }

            return {
                ...state,
                reservationResult: {
                    ...state.reservationResult,
                    guestNames: additionalGuests
                },
                pageErrors: {
                    ...state.pageErrors,
                    [PageErrorType.langError]: {...state.pageErrors[PageErrorType.langError], isErrored: false}
                }
            }

        case Actions.ADDITIONALGUESTINFOMODIFYERROR:
            const indexForError: number = payload.index;
            const fieldNameForGuestForError: string = payload.fieldName;
            let additionalGuestsForError: GuestName[] = JSON.parse(JSON.stringify(state.reservationResult.guestNames));
            let guestNameForError: GuestName = additionalGuestsForError[indexForError];

            if(fieldNameForGuestForError === "firstName") {
                guestNameForError.firstName = "";
                guestNameForError.errors.firstNameError = true;
            } else {
                guestNameForError.lastName = "";
                guestNameForError.errors.lastNameError = true;
            }

            return {
                ...state,
                reservationResult: {
                    ...state.reservationResult,
                    guestNames: additionalGuestsForError
                }
            }

        case Actions.PRIMARYGUESTINFOERROR:
            const errorMap: Map<String, Boolean> = payload.errorMap;
            let primaryGuestInfoErrors: PageErrors = JSON.parse(JSON.stringify(state.pageErrors));
            
            errorMap.forEach((value: Boolean, key: String) => {
                if(value) {
                    switch(key) {
                        case ADDRESS:
                            primaryGuestInfoErrors[PageErrorType.addressError].isErrored = true;
                            break;
                        
                        case CITY:
                            primaryGuestInfoErrors[PageErrorType.cityError].isErrored = true;
                            break;
                            
                        case STATE:
                            primaryGuestInfoErrors[PageErrorType.stateError].isErrored = true;
                            break;

                        case ZIPCODE:
                            primaryGuestInfoErrors[PageErrorType.zipError].isErrored = true;
                            break;

                        case COUNTRY:
                            primaryGuestInfoErrors[PageErrorType.countryError].isErrored = true;
                            break;

                        case EMAIL:
                            primaryGuestInfoErrors[PageErrorType.emailError].isErrored = true;
                            break;

                        case PHONE:
                            primaryGuestInfoErrors[PageErrorType.phoneError].isErrored = true;
                            break;

                        case BONVOYNUMBER:
                            primaryGuestInfoErrors[PageErrorType.bonvoyError].isErrored = true;
                            break;
                    }
                }
            });

            return {
                ...state,
                pageErrors: primaryGuestInfoErrors
            }

        case Actions.TOGGLEPRIMARYINFOERROR:
            const fieldName: string = payload.field;
            let primaryInfoErrors: PageErrors = JSON.parse(JSON.stringify(state.pageErrors));
            switch(fieldName) {
                case ADDRESS:
                    primaryInfoErrors[PageErrorType.addressError].isErrored = true;
                    break;

                case CITY:
                    primaryInfoErrors[PageErrorType.cityError].isErrored = true;
                    break;

                case ZIPCODE:
                    primaryInfoErrors[PageErrorType.zipError].isErrored = true;
                    break;

                case EMAIL:
                    primaryInfoErrors[PageErrorType.emailError].isErrored = true;
                    break;
                
                case PHONE:
                    primaryInfoErrors[PageErrorType.phoneError].isErrored = true;
                    break;
                    
                case BONVOYNUMBER:
                    primaryInfoErrors[PageErrorType.bonvoyError].isErrored = true;
                    break;
                case FIRSTNAME:
                    primaryInfoErrors[PageErrorType.firstNameError].isErrored = true;
                    break;
                case LASTNAME:
                    primaryInfoErrors[PageErrorType.lastNameError].isErrored = true;
                    break;
            }

            return {
                ...state,
                pageErrors: primaryInfoErrors
            }

        case Actions.ADDADDITIONALGUESTS:
            let reservationDetailsToAddGuests: ReservationDetails = JSON.parse(JSON.stringify(state.reservationResult));

            const emptyGuestNameToAdd: GuestName = {
                firstName: "",
                lastName: "",
                errors: {
                    firstNameError: false,
                    lastNameError: false
                }
            };
            
            reservationDetailsToAddGuests.guestNames.push(emptyGuestNameToAdd);

            return {
                ...state,
                reservationResult: reservationDetailsToAddGuests
            }

        case Actions.REMOVEADDITIONALGUEST:
            const indexToRemove: number = payload.index;

            let reservationDetailsToModify: ReservationDetails = JSON.parse(JSON.stringify(state.reservationResult));

            // let additionalGuestsinReservation: GuestName[] = JSON.parse(JSON.stringify(state.reservationResult.guestNames));

            reservationDetailsToModify.guestNames = reservationDetailsToModify.guestNames.filter((guest: GuestName, index: number) => {
                return indexToRemove !== index;
            });

            console.log(JSON.stringify(reservationDetailsToModify.guestNames));

            return {
                ...state,
                reservationResult: reservationDetailsToModify
            }

        case Actions.TERMS:
            const newTerms: Term[] = JSON.parse(JSON.stringify(state.terms));

            const term = newTerms.find(term => term.type === payload.type);

            if(term) {
                term.checked = !term.checked;
            }

            let pageErrorsAfterTandC: PageErrors = JSON.parse(JSON.stringify(state.pageErrors));

            if(state.pageErrors.tandcError.isErrored && !newTerms.some((term: Term) => { return term.acknowledgementNeeded === "true" && !term.checked})) {
                pageErrorsAfterTandC.tandcError.isErrored = false;
            }

            return {
                ...state,
                pageErrors: pageErrorsAfterTandC,
                terms: newTerms
            }

        case Actions.RESETTERMS:
            const tnC: Term[] = JSON.parse(JSON.stringify(state.terms));

            tnC.find(term => term.checked = false);
    
            return {
                ...state,
                terms: tnC
            }

        case Actions.SETRADIOBUTTON:
            const radioAction = payload.action;

            let guestRadioButtonOnRadioChange = JSON.parse(JSON.stringify(state.reservationResult.guestRadioButton));

            if(radioAction === "YES") {
                // guestRadioButtonOnRadioChange[0].checked = true;
                // guestRadioButtonOnRadioChange[1].checked = false;
                if(guestRadioButtonOnRadioChange[0].description.includes('I do NOT intend to stay')) {
                    guestRadioButtonOnRadioChange[0].checked = false;
                    guestRadioButtonOnRadioChange[1].checked = true;
                } else {
                    guestRadioButtonOnRadioChange[0].checked = true;
                    guestRadioButtonOnRadioChange[1].checked = false;
                }
            } else {
                // guestRadioButtonOnRadioChange[0].checked = false;
                // guestRadioButtonOnRadioChange[1].checked = true;
                
                if(guestRadioButtonOnRadioChange[0].description.includes('I do NOT intend to stay')) {
                    guestRadioButtonOnRadioChange[0].checked = true;
                    guestRadioButtonOnRadioChange[1].checked = false;
                } else {
                    guestRadioButtonOnRadioChange[0].checked = false;
                    guestRadioButtonOnRadioChange[1].checked = true;
                }
            }

            return {
                ...state,
                reservationResult: {
                    ...state.reservationResult,
                    guestRadioButton: guestRadioButtonOnRadioChange
                }
            }

        case Actions.API_LOADING:
            return {
                ...state,
                apiLoading: payload
            }
        default:
            return InitState;
    }
}